import { useEffect, useState } from 'react';

const MOBILE_MAX = 767;
const TABLET_MAX = 1220;

export function useBreakpoint() {
  const getDevice = (width) => {
    if (width <= MOBILE_MAX) return 'mobile';
    if (width <= TABLET_MAX) return 'tablet';
    return 'desktop';
  };

  const [breakpoint, setBreakpoint] = useState(() =>
    typeof window !== 'undefined' ? getDevice(window.innerWidth) : 'desktop'
  );

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getDevice(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: breakpoint === 'mobile',
    isTablet: breakpoint === 'tablet',
    isDesktop: breakpoint === 'desktop',
    breakpoint,
  };
}
